// extracted by mini-css-extract-plugin
export default {"Container":"TechTeamSec_Container__wZjsp","begin":"TechTeamSec_begin__Vldat","CardContainer":"TechTeamSec_CardContainer__3q29g"};